import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrialStep } from '../../../shared/types/common';

export interface TrialStepInfo {
  number: number;
  label: string;
}

@Component({
  selector: 'app-trial-step-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './trial-step-indicator.component.html',
  styleUrl: './trial-step-indicator.component.scss',
})
export class TrialStepIndicatorComponent {
  @Input() currentStep = TrialStep.REGISTER_EMAIL;
  
  steps: TrialStepInfo[] = [
    { number: TrialStep.REGISTER_EMAIL, label: 'Register' },
    { number: TrialStep.SELECT_BRAND, label: 'Brand' },
    { number: TrialStep.PROFILE, label: 'Profile' }
  ];

  isStepCompleted(stepNumber: number): boolean {
    return stepNumber < this.currentStep;
  }

  isStepActive(stepNumber: number): boolean {
    return stepNumber === this.currentStep;
  }

  isStepPending(stepNumber: number): boolean {
    return stepNumber > this.currentStep;
  }
}
